import { createContext, useContext } from "react";
import type { GoodsReceipt } from "../types/goods-receipt.types";

export interface GoodsReceiptOverviewContextType {
  goodsReceipt: GoodsReceipt | null;
  refetch: () => Promise<void>;
}

const GoodsReceiptOverviewContext =
  createContext<GoodsReceiptOverviewContextType | null>(null);

export function useGoodsReceiptOverview() {
  const context = useContext(GoodsReceiptOverviewContext);
  if (!context) {
    throw new Error(
      "useGoodsReceiptOverview must be used within GoodsReceiptOverviewContext.Provider",
    );
  }
  return context;
}

export default GoodsReceiptOverviewContext;
